import "lazysizes/plugins/object-fit/ls.object-fit";
import "lazysizes/plugins/parent-fit/ls.parent-fit";
import "lazysizes/plugins/rias/ls.rias";
import "lazysizes/plugins/bgset/ls.bgset";
import "lazysizes";
import "lazysizes/plugins/respimg/ls.respimg";

import {cookiesEnabled} from '../utils/cookiesEnabled';
import {focusHash, bindInPageLinks} from '@shopify/theme-a11y';

import '../components/fields';

import "../styles/theme.scss";
import { docReady } from "../utilities";

docReady(function() {
    document.body.classList.add('ready');
});

// Common a11y fixes
focusHash();
bindInPageLinks();


// Apply a specific class to the html element for browser support of cookies.
if (cookiesEnabled()) {
  document.documentElement.className = document.documentElement.className.replace(
    "supports-no-cookies",
    "supports-cookies"
  );
}
